export const COOKIE_MAX_AGE = 31536000
export const COOKIE_WARNING_ACCEPTED = 'gp__cookie__consent'
